import { Component, Vue, Watch,Prop } from 'vue-property-decorator';
import { getModule} from 'vuex-module-decorators';
import axios, {AxiosPromise}  from 'axios';

import User from "@/module/store/user";
import {CONFIG_ENV} from '@/config';
import {I_Partaker} from "@/types/iPartaker";
import EditPartakerForList from "@/components/EditPartakerForList/EditPartakerForList"

interface I_PartakerForList extends I_Partaker{
    listid:number
}


interface I_AjaxResponse_GetListPartakers{
    status:number,
    statusText:string,
    data: {
        status:string,
        message:string,
        list_partakers:Array<I_PartakerForList>
    }
}

interface I_AjaxResponse_DeletePartakerFromList{
    status:number,
    statusText:string,
    data: {
        status:string,
        message:string,
    }
}

interface I_AjaxResponse_DistribuieLista{
    status:number,
    statusText:string,
    data: {
        status:string,
        message:string,
    }
}

@Component({components:{EditPartakerForList}})
export default class PartakersList extends Vue {
    @Prop() listid!: number;
    @Prop() editable!:boolean;
    @Prop() list_name!:string;
    @Prop() token_lista!:string;
    myBoolTrue:boolean=true;
    myBoolFalse:boolean=false;
    xsm:string='xsm';
    ajaxIsLoadinPartakers:boolean=false;
    dialogAddChildToList:boolean=false;
    currentChildComponent:string='';
    childid_for_edit:number=0;
    ajaxRunningDistribuieLista:boolean=false;

    listPartakers:Array<I_PartakerForList>=[];

    $refs:any;
    private userStore=getModule(User)

    constructor(){
        super();
    }

    async deletePartakerFromList(ppartaker:I_PartakerForList){
        const vueInst=this;
        let res = await <Promise<I_AjaxResponse_DeletePartakerFromList>> axios.post(`${CONFIG_ENV.URL_GIFTS.delete_partaker_from_list}/${ppartaker.listid}/${ppartaker.partakerid}`);
        return res;
    }

    closeChildFormAndReloadPartakersFromDB(){
        const vueInst=this;
        vueInst.dialogAddChildToList=false;
        vueInst.currentChildComponent='';
        vueInst.getListPartakersFromDB(vueInst.listid);
    }

    async distribuieLista(plistid:number){
        return await <Promise<I_AjaxResponse_DistribuieLista>> axios.post(`${CONFIG_ENV.URL_LISTS.markForDistribuieLista}/${plistid}`);
    }

    async getListPartakersFromDB(plistid:number){
        const vueInst=this;
        vueInst.ajaxIsLoadinPartakers=true;
        vueInst.listPartakers=[];
        let url=`${CONFIG_ENV.URL_GIFTS.get_list_partakers}/${plistid}`;
        if(window.location.href.indexOf('view_private_list') !== -1){
            url=`${CONFIG_ENV.URL_GIFTS.get_list_partakers}/${plistid}/${vueInst.token_lista}`;
        }

        let resFromAjax = await <Promise<I_AjaxResponse_GetListPartakers>> axios.get(url);
        resFromAjax.data.list_partakers.forEach((ppartaker:I_PartakerForList)=>{
            vueInst.listPartakers.push({
                partakerid:ppartaker.partakerid,
                listid:ppartaker.listid,
                nume:ppartaker.nume,
                last_name:'',
                first_name:'',
                phone:'',
                email:ppartaker.email,
            });
        });
        vueInst.ajaxIsLoadinPartakers=false;
    }

    openFormNewParticipant(){
        this.childid_for_edit=0;
        this.dialogAddChildToList=true;
        this.currentChildComponent='EditPartakerForList';
    }

    tryToDeletePartakerFromList(ppartaker:I_PartakerForList){
        var vueInst = this;
        this.$q.dialog({
            title: 'Stergere participant din lista',
            message: 'Continuati?',
            cancel: true,
            persistent: true
        }).onOk(() => {
            vueInst.deletePartakerFromList(ppartaker).then((response:I_AjaxResponse_DeletePartakerFromList)=>{
                if(response.data.status=="success"){
                    vueInst.listPartakers.forEach((partaker:I_PartakerForList,index:number)=>{
                        if(partaker.partakerid==ppartaker.partakerid){
                            vueInst.listPartakers.splice(index,1);
                        }
                    })

                }
            })
        });
    }

    fctInParentforActionInGift(info_from_child_comanda:string) {
        var vueInst = this;
        switch (info_from_child_comanda){
            case 'PARTAKER_SAVED':vueInst.closeChildFormAndReloadPartakersFromDB();break;
        }
    }

    tryDistribuieLista(){
        const vueInst=this;


        vueInst.$q.dialog({
            title: 'Confirmare',
            message: 'Doriti sa trimitem lista la persoanele participante?',
            cancel: true,
            persistent: true
        }).onOk(() => {
            vueInst.ajaxRunningDistribuieLista=true;
            vueInst.distribuieLista(vueInst.listid).then(presponse=>{
                vueInst.ajaxRunningDistribuieLista=false;
                if(presponse.data.status=='success'){
                    vueInst.$q.notify({
                        color: 'teal',
                        textColor: 'white',
                        position:'top-right',
                        icon: 'fas fa-exclamation-triangle',
                        message: presponse.data.message
                    });

                }else{
                    vueInst.$q.notify({
                        color: 'red-5',
                        textColor: 'white',
                        position:'top-right',
                        icon: 'fas fa-exclamation-triangle',
                        message: presponse.data.message
                    });
                }
            });
        })


    }

    @Watch("listid",{ deep: true})
    listidChanged(newValue: any, oldValue: any) {
       // console.log('%c listidChanged, newValue=%o, oldValue=%o','color:red;font-size:16px;',newValue,oldValue)
        const vueInst=this;
        if(typeof newValue !== 'undefined' && typeof oldValue !== 'undefined'){
            if(vueInst.listid && 1*vueInst.listid>0) {
                vueInst.listPartakers=[];
                vueInst.getListPartakersFromDB(vueInst.listid);
            }
        }
    }

    activated(){
        const vueInst=this;
        vueInst.listPartakers=[];
        if(vueInst.listid && 1*vueInst.listid>0){
            vueInst.getListPartakersFromDB(vueInst.listid);
        }
        else{
            vueInst.$q.notify({
                color: 'red-5',
                textColor: 'white',
                position:'top-right',
                icon: 'fas fa-exclamation-triangle',
                message: 'Lipseste identificatorul listei! Apasati F5 si incercati din nou!'
            });
        }
    }
}
